import React from "react";
import { Route } from "react-router-dom";
import { MensajeriaScreen } from "./MensajeriaScreen";
import { MensajeriaRemasteredScreen } from "../MensajeriaRemastered/MensajeriaRemasteredScreen";
import { MensajeriaIndicadoresScreen } from "../MensajeriaRemastered/MensajeriaIndicadoresScreen";
import { MensajeriaListadoEnviadosScreen } from "./MensajeriaListadoEnviadosScreen";
import { MensajeriaEnviadosDetalleScreen } from "./MensajeriaEnviadosDetalleScreen";

export const MensajeriaListadoScreen = () => {
    return (
        <div className="main-container">
            {/* Para volver a la mensajería original: cambiar <MensajeriaRemasteredScreen /> por <MensajeriaScreen /> */}
            <Route
                path="/Mensajeria/Main"
                exact
                component={() => <MensajeriaRemasteredScreen />}
            />
            <Route
                path="/Mensajeria/Indicadores"
                component={() => <MensajeriaIndicadoresScreen />}
            />
            <Route
                path="/Mensajeria/Listado"
                component={() => <MensajeriaListadoEnviadosScreen />}
            />
            <Route
                path="/Mensajeria/Detalle"
                component={() => <MensajeriaEnviadosDetalleScreen />}
            />
        </div>
    );
};
